import { render } from "./IconMode.vue?vue&type=template&id=ca8be70c"
import script from "./IconMode.vue?vue&type=script&lang=js"
export * from "./IconMode.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__